/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { loadProjects as loadProjectsService } from 'shared/services/loadProjects';
import { showAlert } from 'shared/slices/admin/alert';
import { EAlert } from 'shared/types/alert';
import { TProjectsListState } from 'shared/reducers';
import { TProjectsList } from 'shared/types/project';

/* istanbul ignore next */
export const loadProjects = createAsyncThunk<TProjectsList, void, IThunkApi>(
  'projects/load',
  async (_, { rejectWithValue, extra: context, getState, dispatch }) => {
    /**
     * Пример, чтобы показать, что есть в thunkApi
     *
     *    const {
     *      getState,
     *       extra: { config, logger, httpApi },
     *       dispatch,
     *       rejectWithValue,
     *     } = thunkApi;
     */
    const { page, limit } = getState() as TProjectsListState;

    try {
      const response = await loadProjectsService(context, { page, limit });

      return response;
    } catch (e) {
      /**
       * Используется для проброса данных в payload экшена rejected
       */
      dispatch(showAlert({ message: 'Проекты не загружены', type: EAlert.Error }));

      return rejectWithValue(e);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    // condition: (params, _api) => {
    //   /**
    //    * В api есть стейт и extra
    //    *
    //    * сonst { getState, extra } = api;
    //    */
    //   const { getState } = _api;
    //   const {
    //     demo: { test },
    //   } = getState();
    //   return test;
    // },
  },
);
